var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"md loading"},[_c('svg',{attrs:{"viewBox":"0 0 66 66"}},[_c('circle',{attrs:{"fill":"none","stroke-width":"6","stroke-linecap":"round","cx":"33","cy":"33","r":"30"}})])])}
var staticRenderFns = []

export { render, staticRenderFns }